import { ApolloClient, gql } from '@apollo/client/core';
import { get as _get } from 'lodash';
import {getArgoConfig} from "../../window";
import {Attribute, PreferenceMeta} from "./index";

function getApplicationName(config: any): string {
    return _get(config, 'argo.applicationName', 'Argo');
}

const argoConfig = getArgoConfig() || {};
const appName = getApplicationName(argoConfig);

export class UserPreferenceClient {

    getUserPreferences = async (
        client: ApolloClient<any>, app: string | null,
        userId: string | null, preferenceNames: string[] | null, pageToken: Attribute[] | null = null, noOfPreferences: number = 1): Promise<any> => {
        return await client.query({
            query: gql`
            query getPreferences(
                $app: String,
                $alias: String,
                $preferenceNameList: [String],
                $nextToken: [Attribute_Input],
                $limit: Int) {
                getPreferences(
                    app: $app,
                    alias: $alias,
                    preferenceNameList: $preferenceNameList,
                    nextToken: $nextToken,
                    limit : $limit) {
                        preferenceList {
                            app
                            alias
                            preferenceName
                            preferenceConfig
                        }
                        nextToken {
                            type
                            value
                        }
                }
            }
            `,
            variables: {
                app: app ?? appName,
                alias: userId,
                preferenceNameList: preferenceNames,
                nextToken: pageToken,
                limit: noOfPreferences
            }
        }).then((result: any) => {
            const preferences = result?.data?.getPreferences?.preferenceList || [];
            const nextPage = result?.data?.getPreferences?.nextToken || null;
            return {
                    data: preferences.map((item: { app: any, alias: any, preferenceName: any, preferenceConfig: any }) => ({
                        app: item.app,
                        alias: item.alias,
                        preferenceName: item.preferenceName,
                        preferenceConfig: item.preferenceConfig,
                    })),
                    nextToken: nextPage,
                    status: {
                        code: "200",
                        message: "Successful",
                    },
                };
        }).catch((error: any) => {
                return {
                        data: [],
                        nextToken: [],
                        status: {
                            code: "5xx",
                            message: error.message || "An unknown error occurred",
                        },
                    };
            });
    };

    saveUserPreferences = async (client: ApolloClient<any>, preferenceListInput: PreferenceMeta[], applicationName: string = appName) => {
        return await client.query({
            query: gql`
            query savePreferences(
                $requestList: [SavePreferenceRequest]!) {
                savePreferences(requestList: $requestList) {
                        responseList {
                            app
                            alias
                            preference {
                                preferenceName
                                preferenceConfig
                            }
                            status {
                                code
                                message
                            }
                        }
                }
            }
            `,
            variables: {
                requestList: [{
                    app: applicationName,
                    preferenceList: preferenceListInput
                }]
            }
        });
    };
}